import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { func, bool, oneOfType, string, number } from 'prop-types';
import { currencyFormatter } from '@magalu/stereo-ui-utils';
import { Link, Box } from '../../atoms';
import { Label, LabelTitle, BreakingLine } from './import-taxes.styles';

const ContentBox = _ref => {
  let {
    onLinkClick,
    isIncludeTaxes,
    totalValueImportTax,
    totalValueICMS
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["onLinkClick", "isIncludeTaxes", "totalValueImportTax", "totalValueICMS"]);

  const handleDetailsClick = () => {
    return onLinkClick == null ? void 0 : onLinkClick();
  };

  return /*#__PURE__*/React.createElement(Box, _extends({
    "data-testid": "content-box"
  }, props), isIncludeTaxes && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LabelTitle, {
    "data-testid": "titletaxeslabel"
  }, "+ Imposto de importa\xE7\xE3o ", currencyFormatter({
    value: totalValueImportTax
  }), " e ICMS ", currencyFormatter({
    value: totalValueICMS
  }), "."), /*#__PURE__*/React.createElement(Label, {
    "data-testid": "texttaxeslabel"
  }, "Os impostos s\xE3o calculados de acordo com o ", /*#__PURE__*/React.createElement(BreakingLine, null), "Remessa Conforme.", ' ', /*#__PURE__*/React.createElement(Link, {
    display: "inline",
    color: "text.primary",
    "data-testid": "learn-more",
    onClick: handleDetailsClick
  }, "Saiba mais"))), !isIncludeTaxes && /*#__PURE__*/React.createElement(Label, {
    "data-testid": "texttaxeslabel"
  }, "Impostos de importa\xE7\xE3o ser\xE3o adicionados ao seguir ", /*#__PURE__*/React.createElement(BreakingLine, null), "com a compra.", ' ', /*#__PURE__*/React.createElement(Link, {
    display: "inline",
    color: "text.primary",
    "data-testid": "learn-more",
    onClick: handleDetailsClick
  }, "Saiba mais")));
};

process.env.NODE_ENV !== "production" ? ContentBox.propTypes = {
  onLinkClick: func,
  isIncludeTaxes: bool,
  totalValueImportTax: oneOfType([string, number]),
  totalValueICMS: oneOfType([string, number])
} : void 0;
ContentBox.defaultProps = {
  onLinkClick: undefined,
  isIncludeTaxes: false
};
export default ContentBox;